import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _DetectMultipleSessions;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Tooltip } from '@instructure/ui-tooltip';
import { IconButton } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import { IconInfoLine } from '@instructure/ui-icons';
import Setting from '../Setting';
export var DetectMultipleSessions = /*#__PURE__*/function (_Component) {
  function DetectMultipleSessions() {
    var _this2;
    _classCallCheck(this, DetectMultipleSessions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, DetectMultipleSessions, [].concat(args));
    _defineProperty(_this2, "toggleDetectMultipleSessions", function (event, changeCompleteCb) {
      var _this2$props = _this2.props,
        setQuizDetectMultipleSessions = _this2$props.setQuizDetectMultipleSessions,
        activeQuizId = _this2$props.activeQuizId;
      var value = event.target.checked;
      setQuizDetectMultipleSessions(activeQuizId, value, changeCompleteCb);
    });
    return _this2;
  }
  _inherits(DetectMultipleSessions, _Component);
  return _createClass(DetectMultipleSessions, [{
    key: "renderLabel",
    value: function renderLabel() {
      return /*#__PURE__*/React.createElement("span", null, t('Detect Multiple Sessions'), /*#__PURE__*/React.createElement(Tooltip, {
        renderTip: /*#__PURE__*/React.createElement(View, {
          as: "span",
          display: "inline-block",
          width: "20rem"
        }, t('Warns students accessing the quiz from multiple devices; these sessions are highlighted in the Activity Log,' + ' accessible to admins and those with the necessary permissions.')),
        placement: "end",
        on: ['click', 'hover', 'focus']
      }, /*#__PURE__*/React.createElement(IconButton, {
        size: "small",
        renderIcon: IconInfoLine,
        withBackground: false,
        withBorder: false,
        screenReaderLabel: t('Toggle Tooltip')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var detectMultipleSessions = this.props.detectMultipleSessions;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Setting, {
        automationData: "sdk-detect-multiple-sessions-toggle",
        isChecked: detectMultipleSessions,
        label: this.renderLabel(),
        onChange: this.toggleDetectMultipleSessions
      }));
    }
  }]);
}(Component);
_DetectMultipleSessions = DetectMultipleSessions;
_defineProperty(DetectMultipleSessions, "displayName", 'DetectMultipleSessions');
_defineProperty(DetectMultipleSessions, "componentId", "Quizzes".concat(_DetectMultipleSessions.displayName));
_defineProperty(DetectMultipleSessions, "propTypes", {
  setQuizDetectMultipleSessions: PropTypes.func.isRequired,
  detectMultipleSessions: PropTypes.bool.isRequired,
  activeQuizId: PropTypes.string.isRequired
});
export default DetectMultipleSessions;